// core/constants/shared-access.ts
export const ENROLLMENT_SHARED_USER_TYPES = [
    1,  // student
    8,  // college admin
    0, 2, 3, 4, 5, 6, 7 // admin roles
];
